import { cn } from "@/lib/utils";
import { ActionButton, type ActionButtonProps } from "./ActionButton";

type Props = {
	actions: ActionButtonProps[] | undefined;
	className?: string;
	buttonClassName?: string;
};

export const ActionGroup = ({ actions, className, buttonClassName }: Props) => {
	if (actions == null) {
		return null;
	}

	return (
		<div
			className={cn(
				"flex items-center justify-start gap-x-3 gap-y-2 sm:gap-x-6 sm:gap-y-4",
				className,
			)}
		>
			{actions.map((action) => (
				<ActionButton
					key={action.name}
					{...action}
					className={buttonClassName}
				/>
			))}
		</div>
	);
};
